import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useOffset, usePopupPanel } from '../hooks'
import { Text, Button } from './UI'
import { getParam } from '../utility'

import Confirmation from '../panels/Confirmation'

const SOffsetControls = styled.div<{ active: boolean }>`
	position: absolute;	
	background-color: ${p => p.theme.colors.light};
	border-radius: ${p => p.theme.borderRadius};
	padding: .5rem;

	top: ${p => p.theme.padding};
	right: ${p => p.theme.padding};

	display: ${p => p.active ? 'grid' : 'none'};
	grid-gap: ${p => p.theme.gridGap};
	grid-auto-flow: column;
`

const SLine = styled.div`
	border-radius: ${p => p.theme.borderRadius};
	width: .15rem;
	background-color: ${p => p.theme.colors.primary};
`

export default function OffsetControls() {
    const [isAdmin, setIsAdmin] = useState(false)
    const offset = useOffset()
    const popup = usePopupPanel()

    useEffect(() => {
        setIsAdmin(getParam('admin') === 'true')
    }, [getParam('admin')])

    function saveHandler(): void {
        popup.setContent(
            <Confirmation
                cancel='Cancel'
                confirm='Save'
                confirmHandler={() => offset.save()}
                title='Save'
                description='Save current Offset'
            />)
        popup.setActive(true)
    }

    return (
        <SOffsetControls active={isAdmin}>
            <Button onClick={() => offset.editValue('RotationX', true)}>-</Button>
            <Text middle subTitle primary bold>R</Text>
            <Button onClick={() => offset.editValue('RotationX', false)}>+</Button>
            <SLine />
            <Button onClick={() => offset.editValue('PositionY', true)}>-</Button>
            <Text middle subTitle primary bold>Y</Text>
            <Button onClick={() => offset.editValue('PositionY', false)}>+</Button>
            <SLine />
            <Button onClick={() => offset.editValue('PositionZ', true)}>-</Button>
            <Text middle subTitle primary bold>Z</Text>
            <Button onClick={() => offset.editValue('PositionZ', false)}>+</Button>
            <SLine />
            <Button onClick={() => saveHandler()}>Save</Button>
        </SOffsetControls>
    )
}
